import React from 'react';
import ReactPaginate from 'react-paginate';
import { PRODUCT_STATES } from '../../../pages/AdminProductsPage/constants';
import BarcodeScanField from './BarcodeScanField';
import ProductPackFields from './ProductPackFields';
import ProductCodeScanField from './ProductCodeScanField';

const getStateFilterLabel = (value) => PRODUCT_STATES.find((s) => s.value === value)?.label || value;

const SortHeader = ({ field, label, width, sortBy, sortOrder, onSort }) => {
  const active = sortBy === field;
  return (
    <th
      scope='col'
      style={{ width: width || 'auto', cursor: 'pointer', userSelect: 'none' }}
      onClick={() => onSort(field)}
    >
      {label}
      {active && (
        sortOrder === 'asc'
          ? <i className='bi bi-arrow-up ml-1' style={{ fontSize: '0.875rem' }}></i>
          : <i className='bi bi-arrow-down ml-1' style={{ fontSize: '0.875rem' }}></i>
      )}
    </th>
  );
};

const AdminBarcodeManagementDesktopView = ({
  quantityFrom,
  setQuantityFrom,
  searchFilter,
  setSearchFilter,
  barcodeMode,
  setBarcodeMode,
  categoryIdsFilter,
  setCategoryIdsFilter,
  categories,
  stateFilter,
  setStateFilter,
  showStateDropdown,
  setShowStateDropdown,
  stateDropdownRef,
  resetFilters,
  error,
  loading,
  rows,
  pageCount,
  currentPage,
  handlePageClick,
  onBarcodeSaved,
  onPackSaved,
  onBarcodeError,
  onCodeSaved,
  onCodeError,
  setCurrentPage,
  sortBy,
  sortOrder,
  handleSort,
  handleRefresh
}) => {
  return (
    <div className='col-12 p-0 d-none d-lg-block'>
      <h1 className='h4 mb-3 text-center mt-1'>Менеджмент штрихкодів</h1>

      <div
        className='d-flex flex-wrap align-items-end justify-content-between w-100 mb-3'
        style={{ gap: '0.75rem' }}
      >
        <div
          className='d-flex flex-wrap align-items-end'
          style={{ gap: '0.75rem', flex: '1 1 auto', minWidth: 0 }}
        >
          <div style={{ flex: '1 1 7rem', minWidth: '6.5rem', maxWidth: '100%' }}>
            <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>Кількість від:</p>
            <input
              type='number'
              className='form-control'
              min='0'
              placeholder='напр. 1'
              value={quantityFrom}
              onChange={(e) => {
                setQuantityFrom(e.target.value);
                setCurrentPage(0);
              }}
              style={{ fontSize: '0.875rem' }}
            />
          </div>
          <div style={{ flex: '1 1 9rem', minWidth: '8rem', maxWidth: '100%' }}>
            <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>Штрихкод:</p>
            <select
              className='form-control'
              value={barcodeMode}
              onChange={(e) => {
                setBarcodeMode(e.target.value);
                setCurrentPage(0);
              }}
              style={{ fontSize: '0.875rem' }}
            >
              <option value='all'>Усі товари</option>
              <option value='with'>Зі штрихкодом</option>
              <option value='without'>Без штрихкоду</option>
            </select>
          </div>
          <div style={{ flex: '1 1 10rem', minWidth: '9rem', maxWidth: '100%' }}>
            <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>Категорія:</p>
            <select
              className='form-control'
              value={categoryIdsFilter[0] ?? ''}
              onChange={(e) => {
                const v = e.target.value;
                setCurrentPage(0);
                if (v === '') setCategoryIdsFilter([]);
                else setCategoryIdsFilter([Number(v)]);
              }}
              style={{ fontSize: '0.875rem' }}
            >
              <option value=''>Всі</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: '1 1 12rem', minWidth: '10rem', maxWidth: '100%' }}>
            <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>Статус:</p>
            <div className='position-relative status-dropdown-container' ref={stateDropdownRef}>
              <button
                type='button'
                className='form-control text-left d-flex justify-content-between align-items-center'
                onClick={(e) => {
                  e.stopPropagation();
                  setShowStateDropdown(!showStateDropdown);
                }}
                style={{ fontSize: '0.875rem', backgroundColor: 'white', cursor: 'pointer' }}
              >
                <span>
                  {stateFilter.length === 0
                    ? 'Всі'
                    : stateFilter.length === 1
                      ? getStateFilterLabel(stateFilter[0])
                      : `Обрано: ${stateFilter.length}`}
                </span>
                <i className={`bi bi-chevron-${showStateDropdown ? 'up' : 'down'}`}></i>
              </button>
              {showStateDropdown && (
                <div
                  className='position-absolute w-100 border rounded bg-white shadow-sm'
                  style={{ zIndex: 1000, marginTop: '2px', maxHeight: '200px', overflowY: 'auto' }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className='p-2'>
                    {PRODUCT_STATES.filter((s) => s.value !== '').map((s) => (
                      <div key={s.value} className='form-check d-flex align-items-center'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id={`state-bc-desk-${s.value}`}
                          checked={stateFilter.includes(s.value)}
                          onChange={(e) => {
                            setCurrentPage(0);
                            if (e.target.checked) {
                              setStateFilter([...stateFilter, s.value]);
                            } else {
                              setStateFilter(stateFilter.filter((v) => v !== s.value));
                            }
                          }}
                          style={{ width: '18px', height: '18px', marginTop: '0', cursor: 'pointer', flexShrink: 0 }}
                        />
                        <label
                          className='form-check-label ml-2'
                          htmlFor={`state-bc-desk-${s.value}`}
                          style={{ fontSize: '0.875rem', cursor: 'pointer', marginBottom: '0', flex: 1 }}
                        >
                          {s.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Рядок 2: пошук як на сторінці товарів (без колонки ID) */}
      <div className='row filters mb-3 mx-0'>
        <div className='col-8 py-1 pl-0 pr-1'>
          <p className='mb-1 font-weight-bold' style={{ fontSize: '0.875rem' }}>
            Пошук по назві товару:
          </p>
          <div className='position-relative d-flex align-items-center'>
            <input
              type='text'
              className='form-control pr-4'
              placeholder='Введіть назву або артикул товару'
              value={searchFilter}
              onChange={(e) => {
                setSearchFilter(e.target.value);
                setCurrentPage(0);
              }}
              style={{ fontSize: '0.875rem' }}
            />
            {searchFilter ? (
              <button
                type='button'
                className='btn p-0 border-0 bg-transparent position-absolute'
                style={{ right: '8px', fontSize: '1.1rem', lineHeight: 1, color: '#6c757d', cursor: 'pointer' }}
                onClick={() => {
                  setSearchFilter('');
                  setCurrentPage(0);
                }}
                title='Очистити пошук'
                aria-label='Очистити пошук'
              >
                <i className='bi bi-x'></i>
              </button>
            ) : null}
          </div>
        </div>
        <div className='col-4 py-1 pl-1 pr-0 d-flex align-items-end justify-content-end'>
          <button
            type='button'
            className='btn btn-dark mr-2'
            onClick={handleRefresh}
            style={{ fontSize: '0.875rem' }}
          >
            Оновити
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={resetFilters}
            style={{ fontSize: '0.875rem' }}
          >
            Очистити фільтр та сортування
          </button>
        </div>
      </div>

      {error ? <div className='alert alert-danger py-2'>{error}</div> : null}
      {loading ? <div className='mb-2'>Завантаження…</div> : null}

      <table className='table table-sm table-bordered table-hover' style={{ borderTop: 'none', width: '100%' }}>
        <thead>
          <tr>
            <SortHeader field='name' label='Назва' sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />
            <SortHeader field='code' label='Артикул' width='12rem' sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} />
            <th scope='col' style={{ width: '14rem' }}>Штрихкод</th>
            <th scope='col' style={{ width: '10rem' }}>Штрихкод пачки</th>
            <th scope='col' style={{ width: '6rem' }}>Штук у пачці</th>
          </tr>
        </thead>
        <tbody>
          {!loading && rows.length === 0 ? (
            <tr>
              <td colSpan={5} className='text-center text-muted'>
                Нічого не знайдено
              </td>
            </tr>
          ) : (
            rows.map((p) => (
              <tr key={p.id}>
                <td className='text-break'>{p.name || ''}</td>
                <ProductCodeScanField
                  wrapper='td'
                  product={p}
                  onCodeSaved={onCodeSaved}
                  onCodeError={onCodeError}
                />
                <BarcodeScanField
                  wrapper='td'
                  product={p}
                  onBarcodeSaved={onBarcodeSaved}
                  onBarcodeError={onBarcodeError}
                />
                <ProductPackFields table product={p} onPackSaved={onPackSaved} onBarcodeError={onBarcodeError} />
              </tr>
            ))
          )}
        </tbody>
      </table>

      {pageCount > 1 && (
        <div className='d-flex justify-content-center mt-4'>
          <ReactPaginate
            previousLabel={'<'}
            nextLabel={'>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            forcePage={currentPage}
          />
        </div>
      )}
    </div>
  );
};

export default AdminBarcodeManagementDesktopView;
